import React, { useEffect, useState } from "react";
import "./Profile.css";
import SentRequest from "./SentRequest";
import ReceivedRequest from "./ReceivedRequest";
import Connection from "./Connection";

const Profile = ({ onRequestProcessed }) => {
  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    if (onRequestProcessed) {
      setSelectedTab(1);
    }
  }, [onRequestProcessed]);

  return (
    <div className="all-profile-container">
      <div className="tabs-container">
        <button
          className={`tab-button ${selectedTab === 1 ? "selected-tab" : ""}`}
          onClick={() => setSelectedTab(1)}
        >
          Received
        </button>
        <button
          className={`tab-button ${selectedTab === 0 ? "selected-tab" : ""}`}
          onClick={() => setSelectedTab(0)}
        >
          Sent
        </button>
        <button
          className={`tab-button ${selectedTab === 2 ? "selected-tab" : ""}`}
          onClick={() => setSelectedTab(2)}
        >
          Approved
        </button>
      </div>

      <div className="content-container">
        {selectedTab === 0 && <SentRequest />}
        {selectedTab === 1 && (
          <ReceivedRequest onRequestProcessed={onRequestProcessed} />
        )}
        {selectedTab === 2 && <Connection />}
      </div>
    </div>
  );
};

export default Profile;
